import React, { Component } from 'react'
import { connect } from 'react-redux'
import AppBar from 'material-ui/AppBar'
import Paper from 'material-ui/Paper';
import { Link } from 'react-router-dom'

import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';


import { getPlace } from '../Place/actions'
import { getFood } from '../Food/actions'
import { getOtop } from '../Otop/actions'
import { getHotels } from '../Hotels/actions'
import { getShopping } from '../Shopping/actions'

import { PlacePopularContainer } from '../Place/PlacePopularContainer'
import { FoodPopularContainer } from '../Food/FoodPopularContainer'
import { OtopPopularContainer } from '../Otop/OtopPopularContainer'
import { HotelsPopularContainer } from '../Hotels/HotelsPopularContainer'
import { ShoppingPopularContainer } from '../Shopping/ShoppingPopularContainer'

import {
  addBookmark,
  deleteBookmark,
  clearBookmark
} from './actions'

import language from '../../config/language'

const iconButtonElement = (
  <IconButton
    touch={true}
  >
    <MoreVertIcon color={grey400} />
  </IconButton>
)

const rightIconMenu = (
  <IconMenu iconButtonElement={iconButtonElement}>
    <MenuItem>Delete</MenuItem>
  </IconMenu>
)
class BookmarkContainer extends Component {

  componentDidMount() {
    this.props.getPlace()
    this.props.getFood()
    this.props.getOtop()
    this.props.getHotels()
    this.props.getShopping()
  }

  getContentByContentTypeId(contentType, contentId) {
    const { lang, category } = this.props
    const lookupStateKey = {
      popularPlace: 'place',
      popularFood: 'food',
      popularOtop: 'otop',
      popularHotels: 'hotels',
      popularNews: 'news',
      popularShopping: 'shopping',
    }
    const data = this.props[lookupStateKey[contentType]].find(value => value.id === contentId) || { title: '', description: '', category_id: '' }
    const getCategory = category.find(value => value.id === data.category_id) || ''
    return {
      title: data.title,
      subTitle: getCategory['title_'+lang] || '',
      description: data.description
    }
  }
  renderContent() {
    if (!this.props.bookmark.length) return null 
    return (
      <List>
      {this.props.bookmark.map(value => {
        const  { title, subTitle, description } = this.getContentByContentTypeId(value.contentType, value.contentId)
        return (
          <div>
            <Divider inset={false} />
            <ListItem
              rightIconButton={rightIconMenu}
              primaryText={
                <p
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    lineHeight: '22px'
                  }}>{title}</p>
              }
              containerElement={<Link to={'/details/'+value.contentType+'/'+value.contentId}/>}
              secondaryText={
                <p>
                  {/* <span style={{color: darkBlack}}>หมวดหมู่: {subTitle}</span> */}
                  {language[this.props.lang].details.category}: {subTitle}
                </p>
              }
              secondaryTextLines={1}
            />
          </div>
        )
      })}
      </List>
    )
  }
  render() {
    const getBookmarkByType = type => this.props.bookmark.filter(b => b.contentType === type)
    const getPlaceBookmark = this.props.place.reduce((prev, cur) =>  (
      getBookmarkByType('popularPlace').some(s => s.contentId === cur.id)
      ? [...prev, cur]
      : prev
    ), [])
    const getFoodBookmark = this.props.food.reduce((prev, cur) =>  (
      getBookmarkByType('popularFood').some(s => s.contentId === cur.id)
      ? [...prev, cur]
      : prev
    ), [])
    const getOtopBookmark = this.props.otop.reduce((prev, cur) =>  (
      getBookmarkByType('popularOtop').some(s => s.contentId === cur.id)
      ? [...prev, cur]
      : prev
    ), [])
    const getHotelsBookmark = this.props.hotels.reduce((prev, cur) =>  (
      getBookmarkByType('popularHotels').some(s => s.contentId === cur.id)
      ? [...prev, cur]
      : prev
    ), [])
    const getShoppingBookmark = this.props.shopping.reduce((prev, cur) =>  (
      getBookmarkByType('popularShopping').some(s => s.contentId === cur.id)
      ? [...prev, cur]
      : prev
    ), [])
    return (
      <div>
        <AppBar
          title={'Bookmark'}
          iconElementLeft={
            <IconButton
              onClick={() => this.props.history.goBack()}
            >
              <i className="material-icons">arrow_back</i>
            </IconButton>
          }
          iconElementRight={
            <IconMenu
              iconButtonElement={
                <IconButton touch={true}>
                  <MoreVertIcon color={grey400} />
                </IconButton>
              }>
              <MenuItem onClick={() => this.props.clearBookmark()}>Clear All Bookmark</MenuItem>
            </IconMenu>
          }
          style={{ backgroundColor: '#75b41c' }}
        />
        <Paper>
          {/* {this.renderContent()} */}
          {getPlaceBookmark.length > 0 && (
            <PlacePopularContainer
              hiddenSeemore
              limit={100}
              popular={getPlaceBookmark}
              lang={this.props.lang}
              category={this.props.category}
              bookmark={this.props.bookmark}
              deleteBookmark={this.props.deleteBookmark}
              addBookmark={this.props.addBookmark}
            />
          )}
          {getFoodBookmark.length > 0 && (
            <FoodPopularContainer
              hiddenSeemore
              limit={100}
              popular={getFoodBookmark}
              lang={this.props.lang}
              category={this.props.category}
              bookmark={this.props.bookmark}
              deleteBookmark={this.props.deleteBookmark}
              addBookmark={this.props.addBookmark}
            />
          )}
          {getOtopBookmark.length > 0 && (
            <OtopPopularContainer
              hiddenSeemore
              limit={100}
              popular={getOtopBookmark}
              lang={this.props.lang}
              category={this.props.category}
              bookmark={this.props.bookmark}
              deleteBookmark={this.props.deleteBookmark}
              addBookmark={this.props.addBookmark}
            />
          )}
          {getHotelsBookmark.length > 0 && (
            <HotelsPopularContainer
              hiddenSeemore
              limit={100}
              popular={getHotelsBookmark}
              lang={this.props.lang}
              category={this.props.category}
              bookmark={this.props.bookmark}
              deleteBookmark={this.props.deleteBookmark}
              addBookmark={this.props.addBookmark}
            />
          )}
          {getShoppingBookmark.length > 0 && (
            <ShoppingPopularContainer
              hiddenSeemore
              limit={100}
              popular={getShoppingBookmark}
              lang={this.props.lang}
              category={this.props.category}
              bookmark={this.props.bookmark}
              deleteBookmark={this.props.deleteBookmark}
              addBookmark={this.props.addBookmark}
            />
          )}
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = ({ lang, areas, category, online, bookmark, ...state }) => ({
  place: state.place.list[lang].data,
  food: state.food.list[lang].data,
  otop: state.otop.list[lang].data,
  hotels: state.hotels.list[lang].data,
  news: state.news.list[lang].data,
  shopping: state.shopping.list[lang].data,
  lang,
  areas,
  category,
  online,
  bookmark
})
export default connect(mapStateToProps, {
  deleteBookmark,
  addBookmark,
  clearBookmark,
  getPlace,
  getFood,
  getOtop,
  getHotels,
  getShopping,
})(BookmarkContainer)


// WEBPACK FOOTER //
// ./src/containers/Bookmark/BookmarkContainer.js